import React from "react";
/* image imports */
import grassLeft from "../assets/images/grass/grass-left.png";
import grassRight from "../assets/images/grass/grass-right.png";
import grassCentre from "../assets/images/grass/grass-centre.png";

const GrassButterfly = () => {
  return (
    <div className="grass-butterfly-wrapper">
      <div className="grass-1">
        <img src={grassLeft} alt="" />
      </div>
      <div className="grass-2">
        <img src={grassRight} alt="" />
      </div>
      <div className="grass-3">
        <img src={grassCentre} alt="" />
      </div>
      <div className="butterfly-1"></div>
      <div className="butterfly-2"></div>
    </div>
  );
};

export default GrassButterfly;
